import Error from './Error'

export default Error
